import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=4bbead14&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4bbead14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbead14",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/myInfo/index.vue"
export default component.exports